<template>
    <!-- 选择用户 -->
        <el-dialog
        title="Share Property"
        :visible.sync="showMsgDio"
        :append-to-body="true"
        class="propertyDioBox"
        :close-on-click-modal='false'
        :show-close="true"
        :before-close="close"
        center
        width="770px">
            <div>Property Link</div>
            <el-input
                placeholder=""
                :disabled='true'
                style="margin:15px 0"
                v-model="url">
                <span slot="suffix" class="newBtn-sharing" v-clipboard:copy="url" v-clipboard:success="onCopy" v-clipboard:error="onError">Copy</span>
            </el-input>
            <div>Share Passphrase</div>
            <el-input
                placeholder=""
                style="margin:15px 0"
                maxlength="12"
                v-model="passwordnew">
                <span v-if="showSave" slot="suffix" @click="savePassword" class="newBtn-sharing">Save</span>
            </el-input>
            <div style="text-align:center;margin-top:30px">
                <el-button type="primary" @click="closeOrOpen" style="background:#333;border:none;width:200px;">{{titMsg}}</el-button>
            </div>
        </el-dialog>
</template>

<script>
import {mapActions} from 'vuex'
export default {
    props:{
        showMsgDio:{ 
            type:Boolean,
            default: () => {
                return false
            }
        },
        titMsg:{ 
            type:String,
            default: () => {
                return 'Close Sharing'
            }
        },
        url:{ 
            type:String,
            default: () => {
                return ''
            }
        },
        password:{ 
            type:String,
            default: () => {
                return ''
            }
        },
        id:{ 
            type:String,
            default: () => {
                return ''
            }
        }
    },
    data() {
        return {
            passwordnew:'',
            showSave:false,
            pFlag:false, // 是否修改密码
        }
    },
    methods: {
        ...mapActions(['changeSharing','changeSharingPassword']),
        closeOrOpen(){
            if(!this.passwordnew){
                Utils.alert('','Please enter a 6-12 digit password','error')
                return true
            }
            if(this.passwordnew.split('').length<6){
                Utils.alert('','Please enter a 6-12 digit password','error')
                return true
            }
            let pat = {
                openFlag:this.titMsg=='Close Sharing'?'0':'1',
                propertyId:this.id
            }
            if(this.showSave&&!this.pFlag&&this.titMsg!='Close Sharing'){
                Utils.alert('','Please save the password first','error')
                return
            }else{
                this.changeSharing({pat:pat,callback:res=>{
                    if(res.code==0){
                        this.$emit('cancelSharingSuccess')
                    }
                }})
            }
            
        },
        close(){
            this.$emit('cancelSharing')
        },
        savePassword(){
            if(!this.passwordnew){
                Utils.alert('','Please enter a 6-12 digit password','error')
                return
            }
            if(this.passwordnew.split('').length<6){
                Utils.alert('','Please enter a 6-12 digit password','error')
                return
            }
            let pat = {password:this.passwordnew,propertyId:this.id}
            this.changeSharingPassword({pat:pat,callback:res=>{
                if(res.code == 0){
                    Utils.alert('','Success','success')
                    this.pFlag = true
                }
            }})
        },
        onCopy: function (e) { //copy 成功
            Utils.alert('','Success','success')
        },
        onError: function (e) { //copy 失败
            Utils.alert('','Error','error')
        }
    },
    watch:{
        passwordnew(n,o){
            this.showSave = n==this.password?false:true
        }
    },
    mounted() {
        this.passwordnew = this.password
    },
}
</script>

<style lang='scss'>
    .newBtn-sharing{
        display: inline-block;
        color: #409eff;
        line-height: 40px;
        box-sizing: border-box;
        padding-right: 10px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/sharing.vue